module.exports = __webpack_public_path__ + "static/img/图层 36.56fefa54.png";